import bundle from './bundle';
import PermalinkButton from './permalink-button';

const plugin = {
  pluginName: 'Permalink',
  enabled: true,
  bundle: bundle,
  components:[{
    component: PermalinkButton,
    region: 'left-sidebar-bottom',
    sortOrder: 20
  }],
}

export default plugin;